// 登入
const login = [
  {
    path: 'login',
    component: resolve => require(['@/components/assist/login/index'], resolve),
    meta: {bgColor: '#fff'}
  }
]

// 忘记密码
const forget = [
  {
    path: 'forget',
    component: resolve => require(['@/components/assist/forget/index'], resolve),
    meta: {bgColor: '#fff'}
  }
]

// 注册
const register = [
  {
    path: 'register',
    component: resolve => require(['@/components/assist/register/index'], resolve),
    meta: {bgColor: '#fff'}
  }
]

// 信息补全
const perfect = [
  {
    path: 'perfect',
    component: resolve => require(['@/components/assist/perfect/index'], resolve)
  }
]

export default [
  {
    path: '/assist',
    component: resolve => require(['@/components/assist/index'], resolve),
    children: [
      ...login,
      ...perfect,
      ...register,
      ...forget
    ],
    redirect: '/assist/login'
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/assist.js